export const contactTranslations = {
  en: {
    // Main contact page
    'contact.title': 'Contact Us',
    'contact.subtitle': 'Ready to start your construction project? Get in touch with our team of experts.',
    'contact.hero.subtitle': 'Ready to start your construction project? Get in touch with our team of experts. We\'re here to help bring your vision to life.',
    
    // Contact form
    'contact.form.title': 'Get a Free Quote',
    'contact.form.subtitle': 'Fill out the form below and our team will get back to you within 24 hours to discuss your project requirements.',
    'contact.form.firstName': 'First Name',
    'contact.form.firstNamePlaceholder': 'Enter your first name',
    'contact.form.lastName': 'Last Name',
    'contact.form.lastNamePlaceholder': 'Enter your last name',
    'contact.form.email': 'Email Address',
    'contact.form.emailPlaceholder': 'Enter your email address',
    'contact.form.phone': 'Phone Number',
    'contact.form.phonePlaceholder': 'Enter your phone number',
    'contact.form.company': 'Company Name',
    'contact.form.companyPlaceholder': 'Enter your company name',
    'contact.form.projectType': 'Project Type',
    'contact.form.projectTypePlaceholder': 'Select project type',
    'contact.form.message': 'Project Details',
    'contact.form.messagePlaceholder': 'Tell us about your project requirements, timeline, and any specific needs...',
    'contact.form.submit': 'Send Message',
    'contact.form.sending': 'Sending Message...',
    'contact.form.success.title': 'Thank You!',
    'contact.form.success.message': 'Your message has been sent successfully. We\'ll get back to you within 24 hours.',
    
    // Project types
    'contact.form.projectTypes.commercial': 'Commercial Construction',
    'contact.form.projectTypes.residential': 'Residential Development',
    'contact.form.projectTypes.infrastructure': 'Infrastructure Projects',
    'contact.form.projectTypes.renovation': 'Renovation & Remodeling',
    'contact.form.projectTypes.projectManagement': 'Project Management',
    'contact.form.projectTypes.design': 'Design & Engineering',
    'contact.form.projectTypes.other': 'Other',
    
    // Contact information
    'contact.info.title': 'Get in Touch',
    'contact.info.subtitle': 'Our team is ready to help you with your construction project. Reach out to us through any of the following channels.',
    'contact.info.phone.title': 'Phone',
    'contact.info.phone.hours': 'Mon - Fri: 8:00 AM - 6:00 PM',
    'contact.info.email.title': 'Email',
    'contact.info.email.response': 'We\'ll respond within 24 hours',
    'contact.info.office.title': 'Office',
    'contact.info.hours.title': 'Business Hours',
    'contact.info.hours.weekdays': 'Saturday- Wednesday: 8:00 AM - 5:00 PM',
    'contact.info.hours.thursday': 'Thursday: 8:00 AM - 2:30 PM',
    'contact.info.hours.weekend': 'Friday: Closed',
    'contact.info.hours.saturday': 'Friday: Closed',
    'contact.info.hours.sunday': '',
    
    // Urgent contact
    'contact.urgent.title': 'Need Immediate Assistance?',
    'contact.urgent.message': 'For urgent inquiries or emergency situations, call our 24/7 hotline.',
    
    // Map section
    'contact.map.title': 'Visit Our Office',
    'contact.map.subtitle': 'Stop by our office to meet our team and discuss your project in person.',
    'contact.map.placeholder.title': 'Interactive Map',
    'contact.map.placeholder.subtitle': 'Google Maps integration coming soon',
    
    // FAQ section
    'contact.faq.title': 'Frequently Asked Questions',
    'contact.faq.subtitle': 'Get answers to common questions about working with FMC Construction.',
    'contact.faq.q1': 'How quickly can you start a project?',
    'contact.faq.a1': 'Project start times vary based on scope and complexity. We typically begin within 2-4 weeks after contract signing, depending on permitting and material availability.',
    'contact.faq.q2': 'Do you provide free estimates?',
    'contact.faq.a2': 'Yes, we provide free, detailed estimates for all projects. Our team will visit your site and provide a comprehensive quote within 48-72 hours.',
    'contact.faq.q3': 'What areas do you serve?',
    'contact.faq.a3': 'We serve the entire metropolitan area and surrounding regions within a 100-mile radius. Contact us to confirm coverage for your specific location.',
    'contact.faq.q4': 'Do you handle permits and inspections?',
    'contact.faq.a4': 'Yes, we handle all necessary permits, inspections, and regulatory compliance. Our team ensures your project meets all local building codes and requirements.',
  },
  ar: {
    // Main contact page
    'contact.title': 'اتصل بنا',
    'contact.subtitle': 'مستعد لبدء مشروع البناء؟ تواصل مع فريقنا من الخبراء.',
    'contact.hero.subtitle': 'مستعد لبدء مشروع البناء؟ تواصل مع فريقنا من الخبراء. نحن هنا لمساعدتك في تحقيق رؤيتك.',
    
    // Contact form
    'contact.form.title': 'احصل على عرض سعر مجاني',
    'contact.form.subtitle': 'املأ النموذج أدناه وسيعود فريقنا إليك خلال ٢٤ ساعة لمناقشة متطلبات مشروعك.',
    'contact.form.firstName': 'الاسم الأول',
    'contact.form.firstNamePlaceholder': 'أدخل اسمك الأول',
    'contact.form.lastName': 'اسم العائلة',
    'contact.form.lastNamePlaceholder': 'أدخل اسم عائلتك',
    'contact.form.email': 'عنوان البريد الإلكتروني',
    'contact.form.emailPlaceholder': 'أدخل عنوان بريدك الإلكتروني',
    'contact.form.phone': 'رقم الهاتف',
    'contact.form.phonePlaceholder': 'أدخل رقم هاتفك',
    'contact.form.company': 'اسم الشركة',
    'contact.form.companyPlaceholder': 'أدخل اسم شركتك',
    'contact.form.projectType': 'نوع المشروع',
    'contact.form.projectTypePlaceholder': 'اختر نوع المشروع',
    'contact.form.message': 'تفاصيل المشروع',
    'contact.form.messagePlaceholder': 'أخبرنا عن متطلبات مشروعك والجدول الزمني وأي احتياجات محددة...',
    'contact.form.submit': 'إرسال الرسالة',
    'contact.form.sending': 'جاري إرسال الرسالة...',
    'contact.form.success.title': 'شكراً لك!',
    'contact.form.success.message': 'تم إرسال رسالتك بنجاح. سنعود إليك خلال ٢٤ ساعة.',
    
    // Project types
    'contact.form.projectTypes.commercial': 'البناء التجاري',
    'contact.form.projectTypes.residential': 'التطوير السكني',
    'contact.form.projectTypes.infrastructure': 'مشاريع البنية التحتية',
    'contact.form.projectTypes.renovation': 'التجديد وإعادة التصميم',
    'contact.form.projectTypes.projectManagement': 'إدارة المشاريع',
    'contact.form.projectTypes.design': 'التصميم والهندسة',
    'contact.form.projectTypes.other': 'أخرى',
    
    // Contact information
    'contact.info.title': 'تواصل معنا',
    'contact.info.subtitle': 'فريقنا مستعد لمساعدتك في مشروع البناء. تواصل معنا من خلال أي من القنوات التالية.',
    'contact.info.phone.title': 'الهاتف',
    'contact.info.phone.hours': 'الاثنين - الجمعة: ٨:٠٠ ص - ٦:٠٠ م',
    'contact.info.email.title': 'البريد الإلكتروني',
    'contact.info.email.response': 'سنرد خلال ٢٤ ساعة',
    'contact.info.office.title': 'المكتب',
    'contact.info.hours.title': 'ساعات العمل',
    'contact.info.hours.weekdays': 'السبت - الأربعاء: ٨:٠٠ ص - ٥:٠٠ م',
    'contact.info.hours.thursday': 'الخميس: ٨:٠٠ ص - ٢:٣٠ م',
    'contact.info.hours.weekend': 'الجمعة: مغلق',
    'contact.info.hours.saturday': 'الجمعة: مغلق',
    'contact.info.hours.sunday': '',
    
    // Urgent contact
    'contact.urgent.title': 'تحتاج مساعدة فورية؟',
    'contact.urgent.message': 'للاستفسارات العاجلة أو الحالات الطارئة، اتصل بخطنا الساخن على مدار الساعة.',
    
    // Map section
    'contact.map.title': 'زر مكتبنا',
    'contact.map.subtitle': 'توقف عند مكتبنا لمقابلة فريقنا ومناقشة مشروعك شخصياً.',
    'contact.map.placeholder.title': 'خريطة تفاعلية',
    'contact.map.placeholder.subtitle': 'تكامل خرائط جوجل قريباً',
    
    // FAQ section
    'contact.faq.title': 'الأسئلة الشائعة',
    'contact.faq.subtitle': 'احصل على إجابات للأسئلة الشائعة حول العمل مع شركة إف إم سي للبناء.',
    'contact.faq.q1': 'ما مدى سرعة بدء المشروع؟',
    'contact.faq.a1': 'تختلف أوقات بدء المشروع بناءً على النطاق والتعقيد. نبدأ عادةً خلال ٢-٤ أسابيع بعد توقيع العقد، اعتماداً على التصاريح وتوفر المواد.',
    'contact.faq.q2': 'هل تقدمون تقديرات مجانية؟',
    'contact.faq.a2': 'نعم، نقدم تقديرات مجانية ومفصلة لجميع المشاريع. سيزور فريقنا موقعك ويقدم عرض سعر شامل خلال ٤٨-٧٢ ساعة.',
    'contact.faq.q3': 'ما المناطق التي تخدمونها؟',
    'contact.faq.a3': 'نخدم المنطقة الحضرية بأكملها والمناطق المحيطة ضمن دائرة نصف قطرها ١٠٠ ميل. اتصل بنا لتأكيد التغطية لموقعك المحدد.',
    'contact.faq.q4': 'هل تتعاملون مع التصاريح والفحوصات؟',
    'contact.faq.a4': 'نعم، نتعامل مع جميع التصاريح والفحوصات والامتثال التنظيمي الضروري. يضمن فريقنا أن مشروعك يلبي جميع رموز البناء المحلية والمتطلبات.',
  }
};
